import { parseISO, isDate, format, addDays as addDays$1, subDays, differenceInCalendarDays, differenceInMinutes, isBefore, isWithinInterval } from 'date-fns';

const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd';
const UNIX_TIMESTAMP_FORMAT = 'T';
const SHORT_MONTHS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
const LONG_MONTHS = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];

const INVALID_AMOUNT = 'Amount must be an integer';
const INVALID_DATE_OBJECT = 'Date must an instance of Date Object';

/**
 * Browsers will attempt to localize a date string (UTC or local) that is provided without timezone info.
 * Often when we get dates they have already been localized to their timezone for their location but we don't
 * have the timezone. This makes sure the date hasn't been altered by removing whatever time differential was
 * set at the time of parsing.
 *
 * @param {String} dateString
 * @return {Date}
 */
const parseDate = dateString => parseISO(dateString);

/**
 * appends a leading zero to a month
 * @param {Number|String} month
 * @return {String}
 */
const leadingZero = month => parseInt(month, 10) < 10 ? `0${month}` : month;

/**
 * Return a date with a given format.
 * DEFAULT_DATE_FORMAT is used if a format is not provided.
 *
 * @param {String} date the original date
 * @param {String} [format=DEFAULT_DATE_FORMAT] the string format of the outputted date
 * @return {String} the formatted date string
 */
const formatDate = function (date) {
  let dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_DATE_FORMAT;
  if (!isDate(date)) {
    throw new Error(INVALID_DATE_OBJECT);
  }
  return format(date, dateFormat);
};
const getCurrentDate = () => {
  if (typeof DtNow === 'undefined') {
    // server date not available, current client date returned instead
    return new Date();
  }
  return window.DtNow;
};
const getCurrentDateStr = () => {
  return formatDate(getCurrentDate());
};

/**
 *
 * Add the specified number of days to the given date.
 *
 * @param {Date} date
 * @param {Number} amount
 * @returns {Date} the new date with the hours added
 */
const addDays = (date, amount) => {
  if (!isDate(date)) {
    throw new Error(INVALID_DATE_OBJECT);
  }
  if (!Number.isInteger(amount)) {
    throw new Error(INVALID_AMOUNT);
  }
  return addDays$1(date, amount);
};
const getNewDate = function () {
  let date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getCurrentDate();
  return new Date(formatDate(date, 'MM/DD/YYYY'));
};

/**
 *
 * Subtract the specified number of days from the given date.
 *
 * @param {Date} date
 * @param {Number} amount
 */
const subtractDays = (date, amount) => {
  if (!isDate(date)) {
    throw new Error(INVALID_DATE_OBJECT);
  }
  if (!Number.isInteger(amount)) {
    throw new Error(INVALID_AMOUNT);
  }
  return subDays(date, amount);
};
const getDateDiffInDays = (dateLeft, dateRight) => {
  if (!isDate(dateLeft) || !isDate(dateRight)) {
    throw new Error(INVALID_DATE_OBJECT);
  }
  return differenceInCalendarDays(dateLeft, dateRight);
};
const getDateDiffInMinutes = (dateLeft, dateRight) => {
  if (!isDate(dateLeft) || !isDate(dateRight)) {
    throw new Error(INVALID_DATE_OBJECT);
  }
  return differenceInMinutes(dateLeft, dateRight);
};
const getTimeStamp = function () {
  let date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  if (!date) {
    // eslint-disable-next-line no-param-reassign
    date = new Date();
  }
  if (!isDate(date)) {
    throw new Error(INVALID_DATE_OBJECT);
  }
  return formatDate(date, UNIX_TIMESTAMP_FORMAT);
};

/**
 * Check if given date is within the range (inclusive)
 *
 * @param {Date} date
 * @param {Date} startDate
 * @param {Date} endDate
 * @returns {Boolean}
 */
const isWithinDateRange = (date, startDate, endDate) => {
  // date-fns requires start and end to be sequential. This allows non-sequential arguments
  const start = isBefore(startDate, endDate) ? startDate : endDate;
  const end = isBefore(startDate, endDate) ? endDate : startDate;
  return isWithinInterval(date, {
    start,
    end
  });
};

export { DEFAULT_DATE_FORMAT as D, INVALID_AMOUNT as I, LONG_MONTHS as L, SHORT_MONTHS as S, addDays as a, getCurrentDateStr as b, getDateDiffInDays as c, getDateDiffInMinutes as d, getNewDate as e, formatDate as f, getCurrentDate as g, getTimeStamp as h, isWithinDateRange as i, INVALID_DATE_OBJECT as j, leadingZero as l, parseDate as p, subtractDays as s };
//# sourceMappingURL=dateHelpers-cf959379.js.map
